"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SuccessIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
function SuccessIcon(props) {
  let path = /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, "Ic\xF4ne de case coch\xE9e"), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M1006.954 511.963c0 273.323-221.569 494.892-494.892 494.892-273.331 0-494.9-221.569-494.9-494.892s221.569-494.892 494.9-494.892c273.323 0 494.892 221.569 494.892 494.892z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "inherit",
    d: "M512.062 0.002c-148.067 0.117-288.837 64.276-386.049 175.955-97.219 111.671-141.372 259.941-121.085 406.602 1.391 9.241 9.952 15.647 19.209 14.366s15.764-9.765 14.593-19.038c-3-21.85-4.507-43.872-4.5-65.925 0.219-244.013 184.392-448.599 427.046-474.37 242.646-25.764 465.683 135.568 517.156 374.096 51.465 238.521-85.197 477.471-316.882 554.059-231.685 76.58-483.838-33.857-584.659-256.066-4.031-8.351-13.999-11.96-22.436-8.117-8.445 3.836-12.273 13.718-8.624 22.248 105.398 231.865 365.207 350.997 609.681 279.557s399.251-311.734 363.199-563.863c-36.044-252.137-251.957-439.427-506.649-439.506z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "inherit",
    d: "M704.657 403.049l93.86-119.452c3.89-4.789 4.898-11.296 2.64-17.030s-7.437-9.804-13.546-10.648c-6.101-0.844-12.194 1.672-15.921 6.578l-93.86 119.46c-5.773 7.398-4.492 18.077 2.867 23.897 7.398 5.773 18.069 4.492 23.889-2.867z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "inherit",
    d: "M409.663 767.943h1.023c4.867-0.289 9.382-2.656 12.39-6.484l227.959-290.111c5.828-7.413 4.539-18.147-2.875-23.967-7.413-5.828-18.139-4.539-23.967 2.875l-216.062 275.026-157.004-157.004c-6.695-6.468-17.342-6.375-23.92 0.211-6.585 6.578-6.679 17.225-0.211 23.92l170.651 170.651c3.211 3.148 7.523 4.898 12.015 4.882z"
  }));
  return path;
}
